import React, {useState} from 'react';
import {Icon, Modal, Table} from 'semantic-ui-react';
import {Link} from 'react-router-dom';
import moment from 'moment';
import {reverseShortDate} from '../../../common/constants/datesFormat';

const SummaryByTransferModal = ({
  accessoryTransferredTotal,
  accessoryTransfersList,
}) => {
  const [detailCardVisible, setDetailCardVisible] = useState(false);

  const handleModal = (e, value) => {
    e.preventDefault();
    setDetailCardVisible(value);
  };

  return (
    <Modal size='small'
      trigger={<Link to='' onClick={(e) => handleModal(e, true)}>{accessoryTransferredTotal}</Link>}
      header={
        <div className='header flex'>
          <h2 className='flex grow' style={{'margin': 0}}>Detalle por transferencia</h2>
          <Icon className='download' name='close' style={{'margin': 0, 'cursor': 'pointer'}}
            onClick={(e) => handleModal(e, false)} />
        </div>
      }
      open={detailCardVisible}
      content={
        <div className="m-2">
          <Table striped className='dashboard-table'>
            <Table.Header className='orders-table-header'>
              <Table.Row>
                <Table.HeaderCell>Transferencia</Table.HeaderCell>
                <Table.HeaderCell>Orden Despacho</Table.HeaderCell>
                <Table.HeaderCell>Fecha</Table.HeaderCell>
                <Table.HeaderCell>Cantidad</Table.HeaderCell>
                <Table.HeaderCell>Entregados</Table.HeaderCell>
                <Table.HeaderCell>Disponibles</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {
                accessoryTransfersList.map((detail, index) => {
                  return <Table.Row key={index}>
                    <Table.Cell>{detail.transfer}</Table.Cell>
                    <Table.Cell>{detail.dispatchOrder}</Table.Cell>
                    <Table.Cell>{moment(detail.transferDate).format(reverseShortDate)}</Table.Cell>
                    <Table.Cell>{detail.quantity}</Table.Cell>
                    <Table.Cell>{detail.delivered}</Table.Cell>
                    <Table.Cell>
                      {detail.available !== 0 ? <strong>{detail.available}</strong> : detail.available}
                    </Table.Cell>
                  </Table.Row>;
                })
              }
            </Table.Body>
          </Table>
        </div>
      }
    />
  );
};

export default SummaryByTransferModal;
